module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fmtxt1"
  }, [_c('a', {
    attrs: {
      "id": "page_v"
    }
  }), _vm._v("Also by Alan Warner")]), _vm._v(" "), _c('p', {
    staticClass: "fmtxt1"
  }, [_c('em', [_vm._v("Morvern Callar")])]), _vm._v(" "), _c('p', {
    staticClass: "fmtxt"
  }, [_c('em', [_vm._v("These Demented Lands")])]), _vm._v(" "), _c('p', {
    staticClass: "fmtxt"
  }, [_c('em', [_vm._v("The Sopranos/Our Ladies")])]), _vm._v(" "), _c('p', {
    staticClass: "fmtxt"
  }, [_c('em', [_vm._v("The Man Who Walks")])]), _vm._v(" "), _c('p', {
    staticClass: "fmtxt"
  }, [_c('em', [_vm._v("The Worms Can Carry Me to Heaven")])]), _vm._v(" "), _c('p', {
    staticClass: "fmtxt"
  }, [_c('em', [_vm._v("The Stars in the Bright Sky")])]), _vm._v(" "), _c('p', {
    staticClass: "fmtxt"
  }, [_c('em', [_vm._v("The Deadman’s Pedal")])]), _vm._v(" "), _c('p', {
    staticClass: "fmtxt"
  }, [_c('em', [_vm._v("Their Lips Talk of Mischief")])]), _vm._v(" "), _c('p', {
    staticClass: "fmtxt"
  }, [_c('em', [_vm._v("Kitchenly 434")]), _c('a', {
    attrs: {
      "id": "page_vi"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-45c3c9ec","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/fm02.vue
// module id = 63
// module chunks = 0